/*
|--------------------------------------------------------------------------
| Views: Takeover: Carousel Left Rail
|--------------------------------------------------------------------------
*/

/**
 * Carousel Left Rail
 * @namespace
 */
__gh__webApp.views.takeover.carouselLeftRail = {

	/**
	 * Post takeover laydown callbacks
	 * @param {object} takeover - takeover object
	 */
	"callbacks": function(takeover){
		var viewName	= takeover.view.name,
			commonJS	= __gh__webApp.common,
			social		= __gh__webApp.social,
			utilities	= __gh__webApp.utilities;

		//Twitter
		if (commonJS.hasString(viewName.toLowerCase(), "twitter"))
		{
		    social.twitter.loadAllWidgets();
		}
		
		//Map
		if (commonJS.hasString(viewName.toLowerCase(), "map"))
		{
		    utilities.googleMap.loadAllMaps();
		}
		
	},
	
	
	/**
	 * Remove related items that won't be included in the secondary list of headlines
	 */
	"removeRelatedItems": function(relatedItems){
		var itemsToRemove 		= ['mainImage','images','map'];
		return relatedItems.filter(function(obj) {
		  return !__gh__webApp.common.inArray(obj.type,itemsToRemove);
		});
	},

	"getSubView": function(takeover){
		
		var thisObject				= __gh__webApp.views.takeover.carouselLeftRail,
			commonJS				= __gh__webApp.common,
			validateItem 			= __gh__webApp.data.validate.item,
			validateRelatedItems	= __gh__webApp.data.itemValidator,
			item 		 			= takeover.items.main[0],
			hasRelatedContent 		= validateItem.hasRelatedContent(item),
			viewFolder				= "takeovers/carouselLeftRail";
					
		if (!hasRelatedContent) { return false; }	
		
		
		
		//Has Multimedia Check
		var	relatedItems				= item.relatedContent.items,
			hasTwitter 					= validateItem.hasTwitter(item),
			firstRelatedMap				= validateRelatedItems({"data":relatedItems,"required":1,"validationMethod":"hasRelatedMap"});
			
		if (!hasTwitter && !firstRelatedMap) { return false; }
			
		
		
		//Add main image to article
		var mainImagePosition			= validateRelatedItems({"data":relatedItems,"required":1,"validationMethod":"hasRelatedMainImage"});
		takeover.items.main[0].image 	= (mainImagePosition !== false) ? relatedItems[mainImagePosition].items[0] : {};
		

		
		//Choose Sub View
		if (hasTwitter){
			relatedItems 				= thisObject.removeRelatedItems(relatedItems);
			takeover.view.name 			= viewFolder + "/twitter";
			takeover.items.relatedItems	= relatedItems.slice(0,1);
			return takeover;
		}
		
		
		if (firstRelatedMap){
			takeover.view.name 			= viewFolder + "/map";
			takeover.items.map 			= relatedItems[firstRelatedMap].items;
			relatedItems 				= thisObject.removeRelatedItems(relatedItems);
			takeover.items.relatedItems	= relatedItems.slice(0,2);
			return takeover;
		}
		
		return false;		

	}
};
